class t{constructor(t){this.getIcon=t=>t!==null&&t!==undefined?this.dict[t.toString()]:undefined;this.dict=t}}export{t as IconSetStore};
//# sourceMappingURL=IconSetStore.js.map
